/**
 * Created by Ella Ma on 2020/09/10.
 * ------ maintenance history ------
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import { WorkflowEditorSubChromeConfig, WorkflowEditorSubChromeActionType, WorkflowEditorSubChromeEventType } from './workflow-config-sub-chrome.model';
import { AlertWindowService } from '../../../../widgets/alert-window/alert-window.service';
import { WorkflowDialogService } from '../../workflow-dialog/workflow-dialog.service';
import { WorkflowDialogOperations } from '../../workflow-model';

@Component({
    selector: 'tam-workflow-config-sub-chrome',
    templateUrl: './workflow-config-sub-chrome.component.html',
    styleUrls: ['./workflow-config-sub-chrome.component.scss']
})
export class WorkflowConfigSubChromeComponent implements OnInit, OnDestroy {

    @Input() config: WorkflowEditorSubChromeConfig;

    saveBtnLoading: boolean;
    saveDraftLoading: boolean;
    showDraftLink: boolean;

    private _destroySubscriptions: Subscription[] = [];

    constructor(
        private _alertWindow: AlertWindowService,
        private _location: Location,
        private _route: ActivatedRoute,
        private _router: Router,
        private _workflowDialogService: WorkflowDialogService,
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(
            this.config.events$.subscribe(event => this._eventSubjectHandlers(event)),
            this._workflowDialogService.result$.subscribe((data) => {
                this.config.changeRouterBySelf = true;
                this.config.changeRouterBySelfDialog = true;
                if (data.opType === WorkflowDialogOperations.NEW) {
                    // on the edit/new workflow page, click new workflow, need reset page
                    this.config.actions$.next({
                        type: WorkflowEditorSubChromeActionType.resetPage
                    });
                }
            })
        );
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    onCancel() {
        const subscription = this._alertWindow.warn('You have unsaved changes',
            ['Are you sure you want to leave this page?'], 'Leave', 'Stay').subscribe((result: boolean) => {
                if (result) {
                    this.config.changeRouterBySelf = true;
                    const operationType = this._route.snapshot.url[2].path.toUpperCase();
                    if (operationType === WorkflowDialogOperations.DRAFT) {
                        this._router.navigateByUrl('/home');
                    } else {
                        this._location.back();
                    }
                }
                subscription.unsubscribe();
            });
    }

    onClickDraftLink() {
        this.config.actions$.next({
            type: WorkflowEditorSubChromeActionType.onClickDraftLink
        });
    }

    onEditClick() {
        this.config.actions$.next({
            type: WorkflowEditorSubChromeActionType.syncNodes
        });
        this._workflowDialogService.open(WorkflowDialogOperations.EDIT, this.config.config);
    }

    onPublish() {
        this.saveBtnLoading = true;
        this.config.actions$.next({
            type: WorkflowEditorSubChromeActionType.onSave
        });
    }

    onSaveAsDraft() {
        this.saveDraftLoading = true;
        this.config.actions$.next({
            type: WorkflowEditorSubChromeActionType.onSaveAsDraft
        });
    }

    private _eventSubjectHandlers(event) {
        if (event.type === WorkflowEditorSubChromeEventType.setLoading) {
            this.saveBtnLoading = event.payload;
        } else if (event.type === WorkflowEditorSubChromeEventType.draftLinkStatus) {
            this.saveDraftLoading = false;
            this.showDraftLink = !!(this.config.opType !== WorkflowDialogOperations.DRAFT && this.config.config.configuration.draft && this.config.config.configuration.id);
        }
    }
}
